export const queryKeys = {
  NOTIF_CONFIG: 'NOTIF_CONFIG'
};
